import * as React from 'react';
import classnames from 'classnames';
import Base, { Props as BaseProps } from '../Base/Base';
import './Table.css';

export interface Props extends BaseProps {
  /**
   * Controls the style of table which are applicable
   * in different contexts within the UI.
   */
  type?: 'card' | 'flat';
}

/**
 * A styled, standard data table component.
 */
const Table: React.FunctionComponent<Props> = (props: Props) => {
  const { type, ...rest } = props;
  const classes = classnames('Table', `Table--type-${type}`);

  return (
    <Base { ...rest }
        Component="table"
        className={ classes } />
  );
};

Table.defaultProps = {
  type: 'card',
};

export default Table;
